import {
  Box,
  Button,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Textarea,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { fetchController } from "../../utils/FetchController/fetchController";
import { showToast } from "../../utils/Toast/Toast";
import { getHostDomain } from "../../utils/utils";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";

const AddIntent = ({ isOpen, onOpen, onClose, fetchAssistants }) => {
  const baseUrl = getHostDomain();
  const finalRef = useRef(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm();
  const endpoint = "/api/v1/assistant/list?page=1&size=50";
  const urlHit = baseUrl + endpoint;
  const [assistants, setAssistants] = useState([]);
  const hitFetch = async () => {
    try {
      const getData = await fetchController(urlHit, "GET");
      if (getData?.data) {
        const data = getData?.data?.items.map((item) => {
          return {
            value: item.id,
            label: `${item.name}
            (${item.description})
            `,
          };
        });
        if (data) {
          setAssistants(data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (isOpen) {
      hitFetch();
    }
  }, [isOpen]);

  const onSubmit = async (data) => {
    const endpoint = "/api/v1/intent";
    const urlHit = baseUrl + endpoint;
    const body = {
      ...data,
      attributes: {},
      is_active: true,
    };
    const getData = await fetchController(urlHit, "POST", body);
    if (getData?.message) {
      showToast("Intent Added", "success");
      reset();
      fetchAssistants();
      setTimeout(() => {
        onClose();
      }, 1000);
    } else {
      showToast("Oops! Something went wrong.", "error");
    }
  };
  const agency = useContext(AgencyContext);
  const { buttonColorScheme } = agency;
  return (
    <>
      <Modal
        size="xl"
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={() => {
          onClose();
          setValue("name", "");
        }}
      >
        <ModalOverlay />
        <ModalContent height="50vh" width="95%" maxWidth="600px">
          <ModalHeader>Add an intent</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Stack direction="row" mb="4">
                <Box flex="1">
                  <Input
                    placeholder="Name"
                    {...register("name", { required: true })}
                  />
                  {errors.name && (
                    <p style={{ color: "red", fontSize: "11px" }}>
                      Name is required
                    </p>
                  )}
                </Box>
              </Stack>
              <Textarea
                placeholder="only for your reference, not used as part of the prompt"
                {...register("description", { required: true })}
                resize="vertical"
              />
              {errors.description && (
                <p style={{ color: "red", fontSize: "11px" }}>
                  Description is required
                </p>
              )}

              <Button colorScheme={buttonColorScheme} type="submit" mt="4">
                Submit
              </Button>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AddIntent;
